import {
  Dropzone as MantineDropzone,
  DropzoneProps as MantineDropzoneProps,
  type FileWithPath,
} from '@mantine/dropzone';

export type { FileWithPath };
export type DropzoneProps = MantineDropzoneProps;

export const Dropzone = MantineDropzone;

Dropzone.displayName = 'Dropzone';
